import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Home', href: '/you-tube-video-downloader-landing-page', icon: 'Home' },
    { name: 'Download', href: '/download', icon: 'Download' },
    { name: 'Features', href: '/features', icon: 'Star' },
    { name: 'Support', href: '/support', icon: 'HelpCircle' },
  ];

  const isActiveRoute = (href) => {
    return location?.pathname === href;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-panel border-b border-border/20">
      <div className="glass-container">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/you-tube-video-downloader-landing-page" className="flex items-center space-x-3 micro-lift">
            <div className="glass-card p-2">
              <Icon name="Download" size={24} className="text-accent" />
            </div>
            <div className="flex flex-col">
              <span className="text-fluid-lg font-semibold text-foreground">Zee Downloader</span>
              <span className="text-xs text-muted-foreground font-mono">v2.1.0</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navigationItems?.map((item) => (
              <Link
                key={item?.name}
                to={item?.href}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg smooth-transition micro-lift ${
                  isActiveRoute(item?.href)
                    ? 'glass-medium text-accent border border-accent/20' :'text-muted-foreground hover:text-foreground hover:glass-light'
                }`}
              >
                <Icon name={item?.icon} size={18} />
                <span className="text-sm font-medium">{item?.name}</span>
              </Link>
            ))}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-3">
            <Button variant="ghost" size="sm" iconName="Settings" className="micro-lift">
              Settings
            </Button>
            <Button variant="default" size="sm" iconName="Download" className="glass-hover">
              Start Download
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden micro-lift"
            onClick={toggleMobileMenu}
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={20} />
          </Button>
        </div>

        {/* Mobile Navigation */}
        <div className={`md:hidden collapsible ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
          <nav className="py-4 space-y-2 border-t border-border/20">
            {navigationItems?.map((item) => (
              <Link
                key={item?.name}
                to={item?.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg smooth-transition ${
                  isActiveRoute(item?.href)
                    ? 'glass-medium text-accent border border-accent/20' :'text-muted-foreground hover:text-foreground hover:glass-light'
                }`}
              >
                <Icon name={item?.icon} size={20} />
                <span className="font-medium">{item?.name}</span>
              </Link>
            ))}
            
            {/* Mobile Actions */}
            <div className="pt-4 space-y-2 border-t border-border/20">
              <Button variant="ghost" fullWidth iconName="Settings" iconPosition="left">
                Settings
              </Button>
              <Button variant="default" fullWidth iconName="Download" iconPosition="left">
                Start Download
              </Button>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;